<template>
    <div id="register-layout">
        <div v-if="!showSuccessTemplate" class="inner-register-layout">
            <h2>¡Listo!</h2>
            <div class="intro-text">
                <span>
                ¡Gracias por completar las preguntas anteriores!
                A continuación, necesitamos que completes tus datos para poder contactarte y brindarte información y asesoramiento más detallado.
                </span>
            </div>
            <div class="register-form">
                <div class="error-message" v-if="error != ''">   
                    {{error}}


                </div>
                <div class="inner-register-form">
                    <div class="fields-container">
                        <label for="">
                            <span><span style="color: red;">*</span> Nombre</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu Nombre" v-model="form.first_name" type="text"/>
                        </label>
                        <label for="">
                            <span><span style="color: red;">*</span> Apellido</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu Apellido" v-model="form.last_name" type="text"/>
                        </label>
                        <label for="">
                            <span><span style="color: red;">*</span> C.U.I.T.</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu CUIT" v-model="form.cuit" type="text"/>
                        </label>
                        <label for="">
                            <span><span style="color: red;">*</span> Actividad</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu Actividad" v-model="form.activity" type="text"/>
                        </label>
                        <label for="">
                            <span><span style="color: red;">*</span> Localidad</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu Localidad" v-model="form.locality" type="text"/>
                        </label>
                        <label for="">
                            <span><span style="color: red;">*</span> Teléfono</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu Teléfono" v-model="form.telephone" type="text"/>
                        </label>
                        <label for="">
                            <span><span style="color: red;">*</span> Email</span>
                            <input v-on:keyup="checkForm" placeholder="Ingresá tu email" v-model="form.email" type="email"/>
                        </label>
                        <label for="">
                            <span>Web</span>
                            <input v-on:keyup="checkForm" style="margin: 0" placeholder="Ingresá tu Web" v-model="form.web" type="text"/>
                        </label>
                    </div>
                </div>
                <button @click="register" class="button button-send" v-bind:class="{ canSend: formValidated }">Enviar</button>
                <img class="img-mail" src="~@/assets/img/register-form/email.png" alt="Correo imagen ilustrativa"/>
            </div>
        </div>

        <thanks_register v-else/>


    </div>
</template>

<script>

    import {mapGetters, mapActions} from 'vuex';


    export default {

        data() {
            return {
                showSuccessTemplate: false,
                form:{
                    first_name:'',
                    last_name : '',
                    cuit:'',
                    activity:'',
                    locality:'',
                    telephone:'',
                    web:'',
                    email:'',
                },
                error:'',
                formValidated: false,
            };

        },

        methods: {

            register() {

                if(!this.checkForm){
                    return;
                }

                this.updateLoadingState(true);
                console.log(this.form);
                
                Api.sendMailRegister({
                    'form': this.form,
                    'answers_id': this.returnArrayAnswers})
                .then(res=>{
                    console.log(res)
                    this.updateLoadingState(false);
                    this.showSuccessTemplate = true
                }).catch(error=>{
                    console.log(error)
                    this.updateLoadingState(false);
                })

            },

            checkForm: function (e) {
                this.error=""
                if (!this.form.first_name ||
                    !this.form.last_name ||
                    !this.form.cuit ||
                    !this.form.activity ||
                    !this.form.locality ||
                    !this.form.telephone ||
                    !this.form.email) {
                    this.error = 'Debe llenar los campos obligatorios del formulario';
                    this.formValidated = false
                    return false;
                }else if(!this.validEmail(this.form.email)){
                    this.error = 'El correo no tiene un formato valido';
                    this.formValidated = false
                    return false
                }
                this.formValidated = true
                return true;
            },



            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            ...mapActions(['updateLoadingState'])

        },

        components: {

            thanks_register: () => import("../components/includes/thanks-register.vue"),
        },

        computed: {
            ...mapGetters(['returnArrayAnswers', 'returnLoadingState'])
        }


    }


</script>


<style scoped lang="scss">


    #register-layout {

        padding: 75px 0;

        @include sm {
            padding: 0;
        }

        .inner-register-layout {
            h2 {
                margin-bottom: 35px;
            }

            .register-form {
                background-image: url('~@/assets/img/register-form/path.png');
                -webkit-background-size: cover;
                background-size: cover;
                background-repeat: no-repeat;
                height: 741px;
                width: 100%;
                max-width: 1001px;
                position: relative;
                display: flex;
                margin: 50px auto 0;
                padding-top: 5%;
                align-items: center;
                flex-direction: column;

                .error-message{
                    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
                    width: 100%;
                    max-width: 669px;
                    padding: 10px;
                    margin-bottom: 10px;
                    border-radius: 10px;
                    color: white;
                    background: brown;
                }

                @include sm {
                    background: none;
                    padding: 0 25px;
                    height: auto;
                    margin: 50px auto 130px;
                }


                .inner-register-form {
                    background-color: #FFFFFF;
                    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.15);
                    height: 490px;
                    width: 100%;
                    max-width: 669px;
                    border-radius: 24px;

                    @include sm {
                        height: auto;
                        // padding: 100px 0;
                    }

                    .fields-container {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        align-self: center;
                        height: 80%;
                        flex-wrap: wrap;
                        margin: 3% auto 0;


                        .web-field {

                            label {
                                width: 100%;
                            }

                            @include sm {
                                padding: 0;
                                margin: 12px 25px 12px 23px;
                                width: 95%;
                                label {
                                    margin: 12px 25px;

                                    input {

                                    }

                                }

                            }
                        }

                        label {
                            display: flex;
                            flex-direction: column;
                            margin: 12px 25px;
                            width: 40%;

                            @include md {
                                /*margin: 12px 10px;*/
                                /*width: 42%;*/

                                width: 100%;
                            }

                            @include sm {

                            }

                            span {
                                font-size: 14px;
                                font-family: Montserrat, sans-serif;
                                font-weight: bold;
                                color: #666666;
                                margin-right: 8px;
                                display: flex;
                                align-items: center;
                                @include sm {
                                    margin-right: 16px;

                                }
                            }

                            input {
                                padding: 10px 0 5px;
                                border: 0;
                                border-bottom: 1px solid #979797;
                                font-size: 16px;
                                width: 90%;
                                margin: 0 auto;

                                &::placeholder {
                                    color: #BBBBBB;
                                    font-family: Montserrat, sans-serif;
                                    font-weight: 500;
                                }
                            }

                        }


                    }


                }


                button {
                    position: relative;
                    bottom: -5%;
                    @include sm {
                        // position: relative;
                        bottom: -10px;
                    }
                }

                .canSend{
                    background: #008CEF;
                }


                .img-mail {
                    position: absolute;
                    bottom: 0;
                    right: 3%;

                    @include xl {
                        width: 35%;
                        right: 0;
                    }
                    @include sm {
                        display: none;
                    }
                }

            }

        }


    }


</style>
